import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <div className="container-wide flex flex-col items-center justify-center text-center py-32">
        <div className="w-16 h-16 bg-primary-100 rounded-xl flex items-center justify-center mb-6">
          <i className="ri-error-warning-line text-primary-600 text-3xl" />
        </div>
        <h1 className="font-heading text-4xl font-bold text-foreground-900 mb-4">
          Page Not Found
        </h1>
        <p className="text-foreground-600 mb-8">
          The page you are looking for does not exist.
        </p>
        <Link to="/" className="btn-primary">
          Back to Home
        </Link>
      </div>
      <Footer />
    </div>
  );
}